import { API_URL } from "../../../../Repository/URL";
const ButtonImage = process.env.PUBLIC_URL;

export const thumbnailButton = [
  {
    src: `${ButtonImage}/img/ko/png/Button_L705.png`,
    sizetype: "401",
    address: `${API_URL}/img/ko/png/Button_L705.png`,
    view: `/img/ko/400x220/Button_L705.svg`,
  },
  {
    src: `${ButtonImage}/img/ko/png/Button_L706.png`,
    sizetype: "401",
    address: `${API_URL}/img/ko/png/Button_L706.png`,
    view: `/img/ko/400x220/Button_L706.svg`,
  },
  {
    src: `${ButtonImage}/img/ko/png/Button_L716.png`,
    sizetype: "401",
    address: `${API_URL}/img/ko/png/Button_L716.png`,
    view: `/img/ko/400x220/Button_L716.svg`,
  },
  {
    src: `${ButtonImage}/img/ko/png/Button_L718.png`,
    sizetype: "401",
    address: `${API_URL}/img/ko/png/Button_L718.png`,
    view: `/img/ko/400x220/Button_L718.svg`,
  },
  {
    src: `${ButtonImage}/img/ko/png/Button_L719.png`,
    sizetype: "401",
    address: `${API_URL}/img/ko/png/Button_L719.png`,
    view: `/img/ko/400x220/Button_L719.svg`,
  },
];

export const bigButton = [
  {
    src: `${ButtonImage}/img/ko/png/Button_705.png`,
    sizetype: "400",
    address: `${API_URL}/img/ko/png/Button_705.png`,
    view: `img/ko/400x160/Button_705.svg`,
  },
  {
    src: `${ButtonImage}/img/ko/png/Button_706.png`,
    sizetype: "400",
    address: `${API_URL}/img/ko/png/Button_706.png`,
    view: `img/ko/400x160/Button_706.svg`,
  },
  {
    src: `${ButtonImage}/img/ko/png/Button_716.png`,
    sizetype: "400",
    address: `${API_URL}/img/ko/png/Button_716.png`,
    view: `img/ko/400x160/Button_716.svg`,
  },
  {
    src: `${ButtonImage}/img/ko/png/Button_718.png`,
    sizetype: "400",
    address: `${API_URL}/img/ko/png/Button_718.png`,
    view: `img/ko/400x160/Button_718.svg`,
  },
  {
    src: `${ButtonImage}/img/ko/png/Button_719.png`,
    sizetype: "400",
    address: `${API_URL}/img/ko/png/Button_719.png`,
    view: `img/ko/400x160/Button_719.svg`,
  },
];

export const smallButton = [
  {
    src: `${ButtonImage}/img/ko/png/Button_S705.png`,
    sizetype: "170",
    address: `${API_URL}/img/ko/png/Button_S705.png`,
    view: `img/ko/400x160/Button_705.svg`,
  },
  {
    src: `${ButtonImage}/img/ko/png/Button_S706.png`,
    sizetype: "170",
    address: `${API_URL}/img/ko/png/Button_S706.png`,
    view: `img/ko/400x160/Button_706.svg`,
  },
  {
    src: `${ButtonImage}/img/ko/png/Button_S716.png`,
    sizetype: "170",
    address: `${API_URL}/img/ko/png/Button_S716.png`,
    view: `img/ko/400x160/Button_716.svg`,
  },
  {
    src: `${ButtonImage}/img/ko/png/Button_S718.png`,
    sizetype: "170",
    address: `${API_URL}/img/ko/png/Button_S718.png`,
    view: `img/ko/400x160/Button_718.svg`,
  },
  {
    src: `${ButtonImage}/img/ko/png/Button_S719.png`,
    sizetype: "170",
    address: `${API_URL}/img/ko/png/Button_S719.png`,
    view: `img/ko/400x160/Button_719.svg`,
  },
];

export const enThumbnailButton = [
  {
    src: `${ButtonImage}/img/en/400x220/Button01.png`,
    sizetype: "401",
    address: `${API_URL}/img/en/400x220/Button01.png`,
    view: `img/en/400x220/svg/Button01.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x220/Button02.png`,
    sizetype: "401",
    address: `${API_URL}/img/en/400x220/Button02.png`,
    view: `img/en/400x220/svg/Button02.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x220/Button03.png`,
    sizetype: "401",
    address: `${API_URL}/img/en/400x220/Button03.png`,
    view: `img/en/400x220/svg/Button03.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x220/Button05.png`,
    sizetype: "401",
    address: `${API_URL}/img/en/400x220/Button05.png`,
    view: `img/en/400x220/svg/Button05.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x220/Button06.png`,
    sizetype: "401",
    address: `${API_URL}/img/en/400x220/Button06.png`,
    view: `img/en/400x220/svg/Button06.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x220/Button07.png`,
    sizetype: "401",
    address: `${API_URL}/img/en/400x220/Button07.png`,
    view: `img/en/400x220/svg/Button07.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x220/Button08.png`,
    sizetype: "401",
    address: `${API_URL}/img/en/400x220/Button08.png`,
    view: `img/en/400x220/svg/Button08.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x220/Button09.png`,
    sizetype: "401",
    address: `${API_URL}/img/en/400x220/Button09.png`,
    view: `img/en/400x220/svg/Button09.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x220/Button10.png`,
    sizetype: "401",
    address: `${API_URL}/img/en/400x220/Button10.png`,
    view: `img/en/400x220/svg/Button10.svg`,
  },
];

export const enBigButton = [
  {
    src: `${ButtonImage}/img/en/400x160/Button01.png`,
    sizetype: "400",
    address: `${API_URL}/img/en/400x160/Button01.png`,
    view: `img/en/400x160/svg/Button01.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x160/Button02.png`,
    sizetype: "400",
    address: `${API_URL}/img/en/400x160/Button02.png`,
    view: `img/en/400x160/svg/Button02.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x160/Button03.png`,
    sizetype: "400",
    address: "https://xrai-api.com/coffeeimg/y300.png",
    address: `${API_URL}/img/en/400x160/Button03.png`,
    view: `img/en/400x160/svg/Button03.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x160/Button05.png`,
    sizetype: "400",
    address: `${API_URL}/img/en/400x160/Button05.png`,
    view: `img/en/400x160/svg/Button05.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x160/Button06.png`,
    sizetype: "400",
    address: `${API_URL}/img/en/400x160/Button06.png`,
    view: `img/en/400x160/svg/Button06.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x160/Button07.png`,
    sizetype: "400",
    address: `${API_URL}/img/en/400x160/Button07.png`,
    view: `img/en/400x160/svg/Button07.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x160/Button08.png`,
    sizetype: "400",
    address: `${API_URL}/img/en/400x160/Button08.png`,
    view: `img/en/400x160/svg/Button08.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x160/Button09.png`,
    sizetype: "400",
    address: `${API_URL}/img/en/400x160/Button09.png`,
    view: `img/en/400x160/svg/Button09.svg`,
  },
  {
    src: `${ButtonImage}/img/en/400x160/Button10.png`,
    sizetype: "400",
    address: `${API_URL}/img/en/400x160/Button10.png`,
    view: `img/en/400x160/svg/Button10.svg`,
  },
];

export const enSmallButton = [
  {
    src: `${ButtonImage}/img/en/170x80/Button01.png`,
    sizetype: "170",
    address: `${API_URL}/img/en/170x80/Button01.png`,
    view: `img/en/400x160/svg/Button01.svg`,
  },
  {
    src: `${ButtonImage}/img/en/170x80/Button02.png`,
    sizetype: "170",
    address: `${API_URL}/img/en/170x80/Button02.png`,
    view: `img/en/400x160/svg/Button02.svg`,
  },
  {
    src: `${ButtonImage}/img/en/170x80/Button03.png`,
    sizetype: "170",
    address: `${API_URL}/img/en/170x80/Button03.png`,
    view: `img/en/400x160/svg/Button03.svg`,
  },
  {
    src: `${ButtonImage}/img/en/170x80/Button05.png`,
    sizetype: "170",
    address: `${API_URL}/img/en/170x80/Button05.png`,
    view: `img/en/400x160/svg/Button05.svg`,
  },
  {
    src: `${ButtonImage}/img/en/170x80/Button06.png`,
    sizetype: "170",
    address: `${API_URL}/img/en/170x80/Button06.png`,
    view: `img/en/400x160/svg/Button06.svg`,
  },
  {
    src: `${ButtonImage}/img/en/170x80/Button07.png`,
    sizetype: "170",
    address: `${API_URL}/img/en/170x80/Button07.png`,
    view: `img/en/400x160/svg/Button07.svg`,
  },
  {
    src: `${ButtonImage}/img/en/170x80/Button08.png`,
    sizetype: "170",
    address: `${API_URL}/img/en/170x80/Button08.png`,
    view: `img/en/400x160/svg/Button08.svg`,
  },
  {
    src: `${ButtonImage}/img/en/170x80/Button09.png`,
    sizetype: "170",
    address: `${API_URL}/img/en/170x80/Button09.png`,
    view: `img/en/400x160/svg/Button09.svg`,
  },
  {
    src: `${ButtonImage}/img/en/170x80/Button10.png`,
    sizetype: "170",
    address: `${API_URL}/img/en/170x80/Button10.png`,
    view: `img/en/400x160/svg/Button10.svg`,
  },
];
